import stringifyAttributes from '../helpers/stringifyAttributes';

export default function () {
    return {
        restrict: 'E',
        template(el, attrs) {
            const propsString = stringifyAttributes(attrs);

            return `
                <div>
                    <radio ${ propsString } value="100" ng-value="100" >Exact</radio>
                    <radio ${ propsString } value="200" ng-value="200" >Approx</radio>
                    <radio ${ propsString } value="300" ng-value="300" >Don't know</radio>
                </div>
            `;
        }
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/accuracy.js